export function getDefaultMarketRateField(schema, marketRateField) {
  if (marketRateField && marketRateField.length > 0) {
    return marketRateField;
  }

  let marketRateFieldObj = [];
  if ((schema === 'TGP/TCOE' && !marketRateField) || schema === 'tgp') {
    marketRateFieldObj = ['totalGuaranteedPay', 'totalCostOfEmployment'];
  } else {
    marketRateFieldObj = ['baseSalary', 'totalCashPaid'];
  }

  return marketRateFieldObj;
}

export function getChartColorByCurrencyScheme(currencyScheme, payDisplayType) {
  if (currencyScheme) {
    if (
      (currencyScheme === 'TGP/TCOE' && payDisplayType === 'Base Salary') ||
      (currencyScheme === 'TGP/TCOE' && payDisplayType === 'Total Guaranteed Pay')
    ) {
      return getChartColorSchemeByScheme('Base/TCC');
    } else if (
      (currencyScheme === 'TGP/TCOE' && payDisplayType === 'Total Cost of Employment') ||
      payDisplayType === 'TCC'
    ) {
      return getChartColorSchemeByScheme('TGP/TCOE');
    }
  }

  return getChartColorSchemeByScheme('Base/TCC');
}

export function getCurrencySchemeName(currencies, countryCode) {
  let currencySchemeName = 'Base/TCC';
  let showMarketRateField = false;

  if (countryCode) {
    let currencySchemes = null;
    if (currencies && currencies.length > 0) {
      currencySchemes = currencies;

      let currencyScheme = currencySchemes.find(o => o.country_code === countryCode);
      if (currencyScheme && currencyScheme.currency_scheme === 'TGP/TCOE') {
        showMarketRateField = true;
        currencySchemeName = currencyScheme.currency_scheme;
      }
    }
  }

  return {
    currencySchemeName,
    showMarketRateField
  };
}

export function redirectToPdf(val) {
  let downloadLocation = '/api/generic-utils/generic-download/downloadGeneric';
  if (window.app.hostname !== 'localhost') {
    downloadLocation = `/${window.app.subsite}${downloadLocation}`;
  }
  downloadLocation = buildUrl(downloadLocation, val, window.app, downloadType);

  if (!downloadLocation) {
    return;
  }

  window.location = downloadLocation;
}

export function getCompanyLogoPath(fileName, subsite) {
  if (fileName && fileName !== '' && subsite) {
    let basePath = '';
    if (window.location.hostname !== 'localhost') {
      basePath = `/${subsite}/app`;
    }

    return `${basePath}/logo/${fileName}`;
  }
}

// will be deprecated. Do not use.
export function mapDispatchToActions(actions) {
  function wrapActions(actionsObj, dispatch, getState) {
    const newActions = {};
    Object.keys(actionsObj).forEach(actionName => {
      newActions[actionName] = (...args) => {
        const result = actionsObj[actionName](...args);
        if (typeof result === 'function') {
          result(dispatch, getState);
        } else {
          dispatch(result);
        }
      };
    });
    return newActions;
  }

  return function getActions() {
    return (dispatch, getState) => {
      return wrapActions(actions, dispatch, getState);
    };
  };
}

// use this one. Not 'mapDispatchToActions'.
export const mapDispatchToProps = modules => {
  return dispatch => {
    const boundActions = {};
    Object.keys(modules).forEach(name => {
      const actionCreators = modules[name];
      if (typeof actionCreators === 'string') return;
      boundActions[name] = bindActionCreators(actionCreators, dispatch);
    });
    return boundActions;
  };
};
